import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c5ec2c6c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c5ec2c6c&prod&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=c5ec2c6c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ec2c6c",
  null
  
)

export default component.exports